import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=46f05e37&scoped=true&"
import script from "./GeneralSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=46f05e37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f05e37",
  null
  
)

export default component.exports